@app.service 'DiscountService', ($resource, csConfig, localStorageService, $q) ->

  @resource = $resource "#{csConfig.chefstepsEndpoint}/api/v0/shopping/discounts/:id", { id: '@id' },
    'show':
      method: 'GET'
      isArray: false

  @get = (discountId) =>
    deferred = $q.defer()

    if @discount
      deferred.resolve @discount
    else
      loadDataSuccess = (data) =>
        @discount = data
        deferred.resolve @discount
      loadDataError = (error) ->
        Rollbar.error("DiscountService - error while loading discount, discountId: #{discountId}, error: #{JSON.stringify(error)}")
        deferred.reject error

      @resource.show({id: discountId}, loadDataSuccess, loadDataError)

    deferred.promise

  this
